const SpacesListing = () => import('../../components/Tenant/Space/List')
const SpacesManage = () => import('../../components/Tenant/Space/Manage')

export default {
    path: 'tenant-spaces',
    redirect: 'tenant-spaces',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'tenant-spaces',
    meta: {'permissions': 'view-tenant-spaces'},
    children: [
        {
            path: '/',
            component: SpacesListing,
        },
        {
            path: 'create',
            name: 'create-tenant-space',
            meta: {'permissions': 'create-tenant-space'},
            component: SpacesManage,
        },
        {
            path: 'update/:id',
            name: 'update-tenant-space',
            meta: {'permissions': 'update-tenant-space'},
            component: SpacesManage,
        },
    ],
};
